import { Work } from '../types/interfaces'

export const works: Work[] = [
  {
    Name: 'Alfabit',
    Position: 'Spezialist für IT-Anwendungen',
    HowLong: '12.2024 - heute',
    Tasks: [
      'Programmierung von Netzwerkdiensten und Anwendungen sowie Websites für Kunden und Unternehmen.',
      'Implementierung von Wireless- und Cloud-Technologien (Automatisierung).',
      'Serveradministration und API-/Datenbankverwaltung. Fehlerbehebung und technischer Kundensupport.',
    ],
  },
  {
    Name: 'Techgroup',
    Position: 'Telekommunikationstechniker',
    HowLong: '08.2025 - 09.2025',
    Tasks: [
      'Verlegung und Montage von Glasfaserkabeln. Wartung und Instandhaltung von Telekommunikationsnetzen.',
      'Konfiguration und Wartung von Netzwerkgeräten und Heim-Internetnetzwerken.',
      'Programmierung von Netzwerkdiensten und Anwendungen.',
    ],
  },
  {
    Name: 'Nationales Zentrum für Kernforschung',
    Position: 'Praktikant in der Abteilung für nukleare Ausrüstung',
    HowLong: '07.2025 - 08.2025',
    Tasks: [
      'Einarbeitung in die Erstellung, Überprüfung und Validierung technologischer Dokumentationen.',
      'Erlernen der Grundlagen der Programmierung von Siemens- und Beckhoff-SPS-Steuerungen.',
      'Erstellung und Testen von Software für den AQURE-Beschleuniger in den Programmiersprachen C++ und C#.',
      'Montage und Inbetriebnahme elektrischer Komponenten von Beschleunigern. Durchführung von Funktionstests.',
    ],
  },
  {
    Name: 'Elepotrik',
    Position: 'Ingenieur im Elektronik-Service',
    HowLong: '08.2024 - 09.2024',
    Tasks: [
      'Diagnose und Reparatur elektronischer Geräte, einschließlich Computer- und Mobilgeräten.',
      'Löten und Austausch elektronischer Komponenten. Bedienung von Diagnosegeräten.',
      'Durchführung von Funktionstests und Softwarereparaturen in Geräten.',
      'Auftragsannahme und Kundenkontakt.',
    ],
  },
  {
    Name: 'Lewe Korki',
    Position: 'Projektgründer, Nachhilfelehrer, Full-Stack-Entwickler',
    HowLong: '07.2023 - 05.2024',
    Tasks: [
      'Erstellung und Pflege einer Bildungsplattform für Nachhilfelehrer und Organisation von Kursen darüber.',
      'Datenbankmanagement – Organisation von Benutzern und Lehrmaterialien.',
      'Nachhilfeunterricht in Physik und Mathematik für Gymnasiasten.',
    ],
  },
  {
    Name: 'Soulgraphy',
    Position: 'Schöpfer und Projektleiter, Front-End-Entwickler',
    HowLong: '11.2020 - 07.2021',
    Tasks: [
      'Erstellung und Entwicklung einer Plattform für politische Tests zur Analyse von Nutzeransichten.',
      'Leitung eines 20-köpfigen Teams, Organisation von Jugenddebatten und Interviews mit Politikern.',
      'Erreichen von Zehntausenden von Besuchen täglich.',
      'Online-Präsenz der Plattform – Tests sind weiterhin unter <a href="https://soulgraphy.me">Soulgraphy</a> verfügbar.',
    ],
  },
]
